define('massage-countries',['require','exports','module','lodash','countries'],function (require, exports, module) {
    var _ = require('lodash');
    var countryNames = require('countries');

    /*
     * massageCountries() returns a new array of objects
     * which includes country title and codes
     *
     * Our current API provides an array of country codes
     *
     * @param <Array> countries
     * @return <Array> countriesWithCodes
     */
    var massageCountries = function (countries) {
        var countriesWithCodes = [];

        // in the event that a single country
        // code is provided as a string
        if (typeof countries === 'string') {
            var country = _.map(countryNames, function (countryResponse) {
                return countryResponse.code;
            }).indexOf(countries);

            return countryNames[country];
        }

        _.forEach(countries, function (countryResponse) {
            _.forEach(countryNames, function (name) {
                if (countryResponse === name.code) {
                    countriesWithCodes.push(name);
                }
            });
        });

        return _.sortBy(countriesWithCodes, 'name');
    };

    module.exports = massageCountries;
});

